// extracted by mini-css-extract-plugin
export default {"PageContainerCss":"pageContainer_mobile_PageContainerCss__avIT4","responsive":"pageContainer_mobile_responsive__oJ4Q1"};